import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LocationMapper } from '../../containers/locationMapper';
import { LocationProvider } from '../../hocs/LocationProvider';
import { setLocation } from '../../store';
import { MapProvider } from '../../hocs/MapProvider';
import { MapView } from '../../components/locationsLayout/mapView';

const Floor = ({ location, routes, path, basename }) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(
      setLocation(
        location.locationKey,
        location.floor,
        location.section,
        location.floorKey,
        location.sectionKey
      )
    );
  }, [dispatch, location]);

  return (
    <>
      <Router basename={`store/details/${basename}${path}/`}>
        {routes.map((route, i) => (
          <FloorRouterSwitch key={i} route={route} />
        ))}
      </Router>
    </>
  );
};

const FloorRouterSwitch = ({ route }) => {
  if (route.path === '/') {
    return <CustomRoute route={route} />;
  } else {
    return (
      <>
        <CustomRoute route={route} />
        <Route
          key={`${route.path}/mapview`}
          path={`${route.path}/mapview`}
          exact={route.exact}
          component={() => (
            <MapProvider
              render={(mapProps) => <MapView mapProps={mapProps} />}
            />
          )}
        />
      </>
    );
  }
};

const CustomRoute = ({ route }) => {
  return (
    <Route
      key={route.path}
      path={route.path}
      exact={route.exact}
      component={() => (
        <LocationProvider
          render={(location) => (
            <LocationMapper
              locationKey={location.locationKey}
              area={route.location}
            />
          )}
        />
      )}
    />
  );
};
export default Floor;
